var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSquareQuestion(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.75 0.625H10.5C11.457 0.625 12.25 1.41797 12.25 2.375V11.125C12.25 12.1094 11.457 12.875 10.5 12.875H1.75C0.765625 12.875 0 12.1094 0 11.125V2.375C0 1.41797 0.765625 0.625 1.75 0.625ZM3.74609 4.28906V4.31641C3.63672 4.64453 3.80078 5.02734 4.15625 5.16406C4.48438 5.27344 4.86719 5.10938 4.97656 4.75391L5.00391 4.72656C5.03125 4.64453 5.11328 4.58984 5.19531 4.58984H6.78125C7.02734 4.58984 7.21875 4.75391 7.21875 5C7.21875 5.13672 7.13672 5.27344 7 5.35547L5.79688 6.03906C5.57812 6.14844 5.46875 6.36719 5.46875 6.61328V6.96875C5.46875 7.35156 5.74219 7.625 6.125 7.625C6.48047 7.625 6.75391 7.35156 6.78125 6.99609L7.65625 6.47656C8.17578 6.17578 8.53125 5.60156 8.53125 5C8.53125 4.04297 7.73828 3.25 6.78125 3.25H5.19531C4.53906 3.25 3.96484 3.66016 3.74609 4.28906ZM5.25 9.375C5.25 9.86719 5.63281 10.25 6.125 10.25C6.58984 10.25 7 9.86719 7 9.375C7 8.91016 6.58984 8.5 6.125 8.5C5.63281 8.5 5.25 8.91016 5.25 9.375Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquareQuestion);
export default ForwardRef;